import React from "react";
import { Form, Input } from "antd";
import ImageSet from "../../../utils/ImageSet";

export const TituloComponent = ({ field, ...props }) => {
  return (
    <Form.Item label="Titulo">
      <Input type="text" {...field} {...props} />
    </Form.Item>
  );
};
export const LinkComponent = ({ field, ...props }) => {
  return (
    <Form.Item label="Link">
      <Input type="text" {...field} {...props} />
    </Form.Item>
  );
};
export const DescripcionComponent = ({ field, ...props }) => {
  return (
    <Form.Item label="Descripción">
      <Input.TextArea
        autosize={{ minRows: 2 }}
        type="text"
        {...field}
        {...props}
      />
    </Form.Item>
  );
};
export const ImageSetComponent = ({ field, ...props }) => {
  return (
    <ImageSet
      {...props}
      {...field}
      values={props.form.values}
      name={field.name}
      label="Set de imagenes"
    />
  );
};
